var map = {
	"./crudeaxe.webp": 7880,
	"./crudeclub.webp": 802,
	"./crudespear.webp": 472,
	"./dagger.webp": 9688,
	"./fist.webp": 504,
	"./longsword.webp": 2730,
	"./revolver.webp": 3716,
	"./shortbow.webp": 5424,
	"./shortsword.webp": 7368,
	"./shotgun.webp": 4776,
	"./spiritstaff.webp": 5000,
	"./warhammer.webp": 3732,
	"./winchester.webp": 7168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5588;